import { useLazyQuery, useQuery } from "@apollo/client";
import { CUSTOMER_TASK } from "../customer-task.queries";
import {
  CustomerTaskQuery,
  CustomerTaskQueryVariables,
} from "../../../__generated__/CustomerTaskQuery";

export const useCustomerTask = (id: number) => {
  return useQuery<CustomerTaskQuery, CustomerTaskQueryVariables>(CUSTOMER_TASK, {
    variables: { id },
  });
};

export const useLazyCustomerTask = () => {
  return useLazyQuery<CustomerTaskQuery, CustomerTaskQueryVariables>(CUSTOMER_TASK);
};
